// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // API_URL: 'http://localhost:3000',
  // VIPPS_OAUTH_ISSUER: 'http://localhost:3000/vipps/access-management-1.0/access',
    API_URL: 'https://backend.soknad.skolen.adamogeva.no',
  VIPPS_OAUTH_ISSUER: 'https://backend.soknad.skolen.adamogeva.no/vipps/access-management-1.0/access',
  APP_TOKEN: 'johngalt42',
  VIPPS_SCOPES: 'api_version_2 openid birthDate address name phoneNumber email',
  VIPPS_API_URL: 'https://api.vipps.no',
  VIPPS_CLIENT_ID: '0d539e55-fd59-47d3-a57f-f1a826f503ac',
  VIPPS_SECRET_ID: 'xwK1hc49uhA_Sp-fDSw6DnKjTPQ=',
  VIPPS_SUBSCRIPTION_ID: '826b5a51d3f9463ba6e537dc414df4ae',
  VIPPS_REDIRECT_URL: 'https://soknad.skolen.adamogeva.no/vipps'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
